"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfHealthService = exports.WarningLightsCategory = void 0;
const types_1 = require("../../shared/types");
const VcfHealthSettingsConverter_1 = require("./VcfHealthSettingsConverter");
var WarningLightsCategory;
(function (WarningLightsCategory) {
    WarningLightsCategory["ASSISTANCE"] = "ASSISTANCE";
    WarningLightsCategory["BRAKE"] = "BRAKE";
    WarningLightsCategory["COMFORT"] = "COMFORT";
    WarningLightsCategory["ENGINE"] = "ENGINE";
    WarningLightsCategory["LIGHTING"] = "LIGHTING";
    WarningLightsCategory["OTHER"] = "OTHER";
    WarningLightsCategory["TIRE"] = "TIRE";
})(WarningLightsCategory || (exports.WarningLightsCategory = WarningLightsCategory = {}));
class VcfHealthService {
    constructor(vcfHealthClient) {
        this.vcfHealthClient = vcfHealthClient;
    }
    async getMaintenanceStatus(vin, devicePlatform) {
        var _a, _b, _c, _d, _e;
        let maintenanceStatusResponse;
        maintenanceStatusResponse = await this.vcfHealthClient.getMaintenanceStatus(vin, this.isWcar(devicePlatform));
        const data = maintenanceStatusResponse.data;
        return {
            inspectionDueDays: (_a = data === null || data === void 0 ? void 0 : data.inspectionDue_days) !== null && _a !== void 0 ? _a : undefined,
            inspectionDueKm: (_b = data === null || data === void 0 ? void 0 : data.inspectionDue_km) !== null && _b !== void 0 ? _b : undefined,
            mileage_km: (_c = data === null || data === void 0 ? void 0 : data.mileage_km) !== null && _c !== void 0 ? _c : undefined,
            oilServiceDueDays: (_d = data === null || data === void 0 ? void 0 : data.oilServiceDue_days) !== null && _d !== void 0 ? _d : undefined,
            oilServiceDueKm: (_e = data === null || data === void 0 ? void 0 : data.oilServiceDue_km) !== null && _e !== void 0 ? _e : undefined,
        };
    }
    async getHealthReportArchives(vin, devicePlatform) {
        const healthReportsResponse = await this.vcfHealthClient.getHealthReports(vin, this.isWcar(devicePlatform));
        if (healthReportsResponse === null || healthReportsResponse === void 0 ? void 0 : healthReportsResponse.data) {
            return this.sortHealthReportsByTimestampDesc(healthReportsResponse.data).map((value) => {
                return {
                    id: value.id,
                    mileageKm: value.mileage_km,
                    lastUpdate: value.carCapturedTimestamp,
                };
            });
        }
        return [];
    }
    async deleteHealthReport(vin, devicePlatform, id) {
        await this.vcfHealthClient.deleteHealthReport(vin, this.isWcar(devicePlatform), id);
    }
    async getLatestHealthReport(vin, devicePlatform) {
        var _a, _b, _c, _d;
        const latestHealthReportResponse = await this.vcfHealthClient.getLatestHealthReport(vin, this.isWcar(devicePlatform));
        let warningLights = (_a = latestHealthReportResponse === null || latestHealthReportResponse === void 0 ? void 0 : latestHealthReportResponse.data.warningLights) !== null && _a !== void 0 ? _a : [];
        warningLights = (_b = warningLights.filter((warningLight) => warningLight.customerRelevance === true)) !== null && _b !== void 0 ? _b : [];
        const groupedWarningLights = this.groupWarningLightsByCategory(warningLights);
        return {
            lastUpdate: (_c = latestHealthReportResponse === null || latestHealthReportResponse === void 0 ? void 0 : latestHealthReportResponse.data) === null || _c === void 0 ? void 0 : _c.carCapturedTimestamp,
            mileageKm: (_d = latestHealthReportResponse === null || latestHealthReportResponse === void 0 ? void 0 : latestHealthReportResponse.data) === null || _d === void 0 ? void 0 : _d.mileage_km,
            groupedWarningLights,
        };
    }
    async getHealthReportById(vin, devicePlatform, id) {
        var _a, _b, _c;
        const healthReportResponse = await this.vcfHealthClient.getHealthReportById(vin, this.isWcar(devicePlatform), id);
        const groupedWarningLights = this.groupWarningLightsByCategory((_a = healthReportResponse === null || healthReportResponse === void 0 ? void 0 : healthReportResponse.data.warningLights) !== null && _a !== void 0 ? _a : []);
        return {
            lastUpdate: (_b = healthReportResponse === null || healthReportResponse === void 0 ? void 0 : healthReportResponse.data) === null || _b === void 0 ? void 0 : _b.carCapturedTimestamp,
            mileageKm: (_c = healthReportResponse === null || healthReportResponse === void 0 ? void 0 : healthReportResponse.data) === null || _c === void 0 ? void 0 : _c.mileage_km,
            groupedWarningLights,
        };
    }
    async getHealthReportSettings(vin, devicePlatform) {
        const healthReportSettingsResponse = await this.vcfHealthClient.getHealthReportSettings(vin, this.isWcar(devicePlatform));
        return VcfHealthSettingsConverter_1.VcfHealthSettingsConverter.convertVcfResponseToHealthReportSettings(healthReportSettingsResponse);
    }
    async saveHealthReportSettings(vin, devicePlatform, healthReportSettings) {
        await this.vcfHealthClient.saveHealthReportSettings(vin, this.isWcar(devicePlatform), VcfHealthSettingsConverter_1.VcfHealthSettingsConverter.convertHealthReportSettingsToVcfData(healthReportSettings));
    }
    async triggerWarningLightsUpdate(vin, devicePlatform) {
        await this.vcfHealthClient.triggerWarningLightsUpdate(vin, this.isWcar(devicePlatform));
    }
    isWcar(devicePlatform) {
        return devicePlatform === types_1.DevicePlatform.WCAR;
    }
    sortHealthReportsByTimestampDesc(healthReports) {
        return healthReports.sort((firstReport, secondReport) => {
            const timestampFirstReport = new Date(firstReport.carCapturedTimestamp).getTime();
            const timestampSecondReport = new Date(secondReport.carCapturedTimestamp).getTime();
            return timestampFirstReport > timestampSecondReport ? -1 : 1;
        });
    }
    groupWarningLightsByCategory(warningLights) {
        const result = [];
        warningLights === null || warningLights === void 0 ? void 0 : warningLights.forEach((warningLight) => {
            var _a;
            const category = warningLight.category;
            if (category) {
                const transformedWarningLight = {
                    text: warningLight.text,
                    icon: (_a = warningLight.icon) !== null && _a !== void 0 ? _a : undefined,
                    priority: warningLight.priority,
                };
                const categoryInResult = result.find((groupedWarningLight) => groupedWarningLight.category === category);
                if (categoryInResult && categoryInResult.warningLights) {
                    categoryInResult.warningLights.push(transformedWarningLight);
                }
                else {
                    result.push({ category, warningLights: [transformedWarningLight] });
                }
            }
        });
        return result;
    }
}
exports.VcfHealthService = VcfHealthService;
//# sourceMappingURL=VcfHealthService.js.map